/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { FilterProjectMonthDtoToJSON, FilterProjectMonthValuesDtoFromJSON, OtherCostListDtoFromJSON, OtherCostListDtoToJSON, ProjectMonthListDtoFromJSON, ProjectMonthListDtoToJSON, } from '../models/index';
/**
 *
 */
export class ControllerPerLeFunzioniDedicateAlControlloDiGestioneApi extends runtime.BaseAPI {
    /**
     * Recupera i costi dalla intranet per tutti i progetti, per anno e mese indicati
     * Recupera costi reali da intranet
     */
    aggiornaCostiRendicontazioniRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['anno'] == null) {
                throw new runtime.RequiredError('anno', 'Required parameter "anno" was null or undefined when calling aggiornaCostiRendicontazioni().');
            }
            if (requestParameters['mese'] == null) {
                throw new runtime.RequiredError('mese', 'Required parameter "mese" was null or undefined when calling aggiornaCostiRendicontazioni().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cdg/aggiorna-costi/anno/{anno}/mese/{mese}`.replace(`{${"anno"}}`, encodeURIComponent(String(requestParameters['anno']))).replace(`{${"mese"}}`, encodeURIComponent(String(requestParameters['mese']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Recupera i costi dalla intranet per tutti i progetti, per anno e mese indicati
     * Recupera costi reali da intranet
     */
    aggiornaCostiRendicontazioni(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.aggiornaCostiRendicontazioniRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Consente al CL o SUPER ADMIN di visualizzare i costi esterni di un progetto
     * Altri costi
     */
    cdgProjectOtherCostsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['idProject'] == null) {
                throw new runtime.RequiredError('idProject', 'Required parameter "idProject" was null or undefined when calling cdgProjectOtherCosts().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cdg/project/{idProject}/other-costs`.replace(`{${"idProject"}}`, encodeURIComponent(String(requestParameters['idProject']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => OtherCostListDtoFromJSON(jsonValue));
        });
    }
    /**
     * Consente al CL o SUPER ADMIN di visualizzare i costi esterni di un progetto
     * Altri costi
     */
    cdgProjectOtherCosts(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.cdgProjectOtherCostsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Aggiorna i costi esterni di un progetto
     * Aggiorna i costi esterni
     */
    cdgProjectOtherCostsUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['idProject'] == null) {
                throw new runtime.RequiredError('idProject', 'Required parameter "idProject" was null or undefined when calling cdgProjectOtherCostsUpdate().');
            }
            if (requestParameters['otherCostListDto'] == null) {
                throw new runtime.RequiredError('otherCostListDto', 'Required parameter "otherCostListDto" was null or undefined when calling cdgProjectOtherCostsUpdate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cdg/project/{idProject}/other-costs/update`.replace(`{${"idProject"}}`, encodeURIComponent(String(requestParameters['idProject']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: OtherCostListDtoToJSON(requestParameters['otherCostListDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => OtherCostListDtoFromJSON(jsonValue));
        });
    }
    /**
     * Aggiorna i costi esterni di un progetto
     * Aggiorna i costi esterni
     */
    cdgProjectOtherCostsUpdate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.cdgProjectOtherCostsUpdateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Cambia lo stato di un progetto in COMPLETED
     */
    completedProjectRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectId'] == null) {
                throw new runtime.RequiredError('projectId', 'Required parameter "projectId" was null or undefined when calling completedProject().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cdg/{projectId}/completedProject`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Cambia lo stato di un progetto in COMPLETED
     */
    completedProject(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.completedProjectRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Consente ai CDG o SUPER ADMIN di modificare i valori di ricavo e costi anche per mesi consolidati
     * Modifica i valori per i progetti passati in input
     */
    projectMonthEditRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['projectMonthListDto'] == null) {
                throw new runtime.RequiredError('projectMonthListDto', 'Required parameter "projectMonthListDto" was null or undefined when calling projectMonthEdit().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cdg/project/edit`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ProjectMonthListDtoToJSON(requestParameters['projectMonthListDto']),
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Consente ai CDG o SUPER ADMIN di modificare i valori di ricavo e costi anche per mesi consolidati
     * Modifica i valori per i progetti passati in input
     */
    projectMonthEdit(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.projectMonthEditRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera tutti i progetti applicando i filtri passati in input
     * Recupera tutti i progetti tramite i filtri
     */
    projectMonthSearchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['year'] == null) {
                throw new runtime.RequiredError('year', 'Required parameter "year" was null or undefined when calling projectMonthSearch().');
            }
            if (requestParameters['month'] == null) {
                throw new runtime.RequiredError('month', 'Required parameter "month" was null or undefined when calling projectMonthSearch().');
            }
            if (requestParameters['filterProjectMonthDto'] == null) {
                throw new runtime.RequiredError('filterProjectMonthDto', 'Required parameter "filterProjectMonthDto" was null or undefined when calling projectMonthSearch().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cdg/project/year/{year}/month/{month}`.replace(`{${"year"}}`, encodeURIComponent(String(requestParameters['year']))).replace(`{${"month"}}`, encodeURIComponent(String(requestParameters['month']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: FilterProjectMonthDtoToJSON(requestParameters['filterProjectMonthDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ProjectMonthListDtoFromJSON(jsonValue));
        });
    }
    /**
     * Recupera tutti i progetti applicando i filtri passati in input
     * Recupera tutti i progetti tramite i filtri
     */
    projectMonthSearch(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.projectMonthSearchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Recupera tutti i filtri applicabili per la ricerca per un progetto
     * Recupera tutti i filtri di ricerca
     */
    projectMonthSearchFiltersRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/cdg/search-filters-values`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => FilterProjectMonthValuesDtoFromJSON(jsonValue));
        });
    }
    /**
     * Recupera tutti i filtri applicabili per la ricerca per un progetto
     * Recupera tutti i filtri di ricerca
     */
    projectMonthSearchFilters(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.projectMonthSearchFiltersRaw(initOverrides);
            return yield response.value();
        });
    }
}
